const type = "SENSOR/";

export const sensorTotalDataConstants = {
  AVG_DATA_REQUEST: `${type}AVG_DATA_REQUEST`,
  AVG_DATA_SUCCESS: `${type}AVG_DATA_SUCCESS`,
  AVG_DATA_FAILURE: `${type}AVG_DATA_FAILURE`,
};
